
export default {
    name: 'PZNotice',
    props: {
        content: {
            type: String,
            default: ''
        },
        duration: {
            type: String,
            default: '10s'
        },
        space: {
            type: String,
            default: '40px'
        },
        background: {
            type: String,
            default: 'transparent'
        },
        margin: {
            type: String,
            default: '0px'
        },
        padding: {
            type: String,
            default: '0'
        }
    },
    data () {
        return {
            delay: '1.5s',
            move: true,
            textWidth: ''
        }
    },
    computed: {
        moveStyle () {
            if (this.move) {
                return {
                    animation: `move ${this.duration} linear ${this.delay} infinite`
                }
            }
            return {}
        }
    },
    watch: {
        content: {
            handler () {
                if (this.content) {
                    this.$nextTick(() => {
                        this.calculateWidth()
                        this.createKeyframes()
                    })
                }
            },
            immediate: true
        }
    },
    methods: {
        calculateWidth () {
            // 获取容器宽度
            const noticeEl = this.$refs.noticeEl
            const textEl = this.$refs.textEl

            if (noticeEl && textEl) {
                const noticeWidth = noticeEl.offsetWidth
                const contentWidth = textEl.offsetWidth
                // 内容宽度大于容器宽度才滚动
                this.move = contentWidth > noticeWidth
                this.textWidth = -contentWidth + 'px'
            }
        },
        createKeyframes () {
            if (this.move && this.textWidth) {
                // 移除已存在的样式
                const existingStyle = document.getElementById('move-keyframes')
                if (existingStyle) {
                    existingStyle.remove()
                }

                // 创建新的样式
                const style = document.createElement('style')
                style.id = 'move-keyframes'
                style.textContent = `
                    @keyframes move {
                        from { transform: translateX(0); }
                        to { transform: translateX(calc(${this.textWidth} - ${this.space})); }
                    }
                `
                document.head.appendChild(style)
            }
        }
    }
}
